import React from 'react';
import { useYoutubeApi } from '../context/YoutubeApiContext';
import { useQuery } from '@tanstack/react-query';

export default function ChannelInfo({ id, name }) {
    const { youtube } = useYoutubeApi();
    const { error, isLoading, data:url } = useQuery({
        queryKey: ['channel', id],
        queryFn: () => youtube.channelImageURL(id),
        staleTime: 1000 * 60 * 5, 
    });
        
    return (
        <div className='d-flex mb-4 my-4 align-items-center'>
            {error && subChannelImage(name)}
            {isLoading && subChannelImage(name)}
            {url && <img className='rounded-circle' src={url} alt={name} style={{ width: '40px', height: '40px'}}/>}
            <p className='fs-5 fw-medium ms-2'>{name}</p>
        </div>
    );
}

const subChannelImage = (name) =>{
return (
    <div className="d-flex justify-content-center align-items-center rounded-circle bg-dark text-white fw-bold" 
        style={{ width: '88px', height: '88px', fontSize: '50px' }}>
        {name[0]}
    </div>

    )
}
